import PropTypes from 'prop-types';
import React from 'react';
import QuestionWrapper from '../response/QuestionWrapper';
import SelectListItem from './SelectListItem';
import SelectListDropdown from './SelectListDropdown';
import SelectListOther from './SelectListOther';
import { t } from '../../../utils/translate';
import getLogic from '../../survey_editor/preview/getLogic';
import SimpleLogicList from '../../survey_editor/preview/SimpleLogicList';

const SelectListQuestion = props => {
  const {
    add_other,
    choices,
    id,
    isDisabled,
    name,
    presentation,
    _type,
  } = props;
  const { logic, pages, showLogic } = props;
  return (
    <QuestionWrapper {...props}>
      {presentation === 'select' ? (
        <div>
          <SelectListDropdown
            name={fieldName(_type, name)}
            questionId={id}
            disabled={isDisabled}
          >
            <option value="">{t('select_an_option')}</option>
            {choices.map(choice => (
              <option key={choice.name} value={choice.name}>
                {choice.text}
              </option>
            ))}
          </SelectListDropdown>{' '}
          <SelectListOther
            add_other={add_other}
            disabled={isDisabled}
            name={`questions[${name}-other-value]`}
            questionId={id}
          />
          <SimpleLogicList
            logic={showLogic ? logic : []}
            pages={pages}
            showChoiceLabel={true}
          />
        </div>
      ) : (
        <ul className="unstyled chc_grp">
          {choices.map((choice, i) => (
            <SelectListItem
              {...choice}
              className="chc--force-align"
              disabled={isDisabled}
              based_on={choice.based_on}
              _type={_type}
              id={choice.id ? choice.id : `choice_${choice.name}`}
              index={i}
              key={choice.name}
              name={fieldName(_type, name)}
              questionId={id}
              questionName={name}
              value={choice.name}
              logic={showLogic ? getLogic(logic, choice) : []}
              pages={pages}
            />
          ))}
        </ul>
      )}
    </QuestionWrapper>
  );
};

const fieldName = (_type, name) =>
  _type === 'Survey::SingleSelect'
    ? `questions[${name}]`
    : `questions[${name}][]`;

SelectListQuestion.propTypes = {
  _type: PropTypes.string.isRequired,
  add_dont_know: PropTypes.bool,
  add_none: PropTypes.bool,
  add_other: PropTypes.bool,
  choices: PropTypes.array,
  id: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  presentation: PropTypes.oneOf(['radio', 'select', 'slider']),
  required: PropTypes.bool,
  text: PropTypes.string.isRequired,

  // used to preview simple logic on overview page
  logic: PropTypes.array,
  showLogic: PropTypes.bool,
  pages: PropTypes.object,
};

SelectListQuestion.defaultProps = {
  choices: [],
};

export default SelectListQuestion;
